module.exports = __webpack_public_path__ + "assets/img/11_829_big.3e4a58e0.jpg";